import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=12f1418b&scoped=true&"
import script from "./ReportItem.vue?vue&type=script&lang=ts&"
export * from "./ReportItem.vue?vue&type=script&lang=ts&"
import style0 from "./ReportItem.vue?vue&type=style&index=0&id=12f1418b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f1418b",
  null
  
)

export default component.exports